import React, { FC } from 'react'
import Typography from '../typography'

//* styles
import GlobalContainer from '../globalContainer'
import { RelatedArticleContainer } from './style'

//* utils
import { LocaleCodes } from '../../../constants/localization.constants'
import { generateCard } from './utils/builder'

type Props = {
  data: any
  locale: string
}

const RelatedArticles: FC<Props> = ({ data, locale = LocaleCodes.ENGLISH.code }) => {
  if (!data) return null

  return (
    <RelatedArticleContainer
      data-cy="relatedArticles"
      $topPadding={data.topPadding || 'Large'}
      $bottomPadding={data.bottomPadding || 'Large'}>
      <GlobalContainer className="RelatedArticle__Outer-Container">
        <Typography className="RelatedArticle__Heading" type="header3">
          Related articles
        </Typography>

        <div className="RelatedArticle__Card-Container">
          {data?.map((element: any, index: number) => generateCard(element, index, locale))}
        </div>
      </GlobalContainer>
    </RelatedArticleContainer>
  )
}

export default RelatedArticles
